import { jsx as n } from "react/jsx-runtime";
import { forwardRef as e } from "react";
import t from "@mui/material/Accordion";
import s from "styled-components";
const l = {
  root: "accordionRoot",
  expanded: "accordionExpanded",
  rounded: "accordionRounded",
  disabled: "accordionDisabled"
}, p = s(t).withConfig({
  displayName: "StyledAccordion"
})([
  "&&.accordionRoot{width:",
  ";color:",
  ";background-color:",
  ";box-shadow:",
  ";border-bottom:",
  ";}&&.accordionRoot.accordionExpanded:first-child{margin-top:0px;}&&.accordionRoot::before{display:none;}"
], ({ $fullWidth: o }) => o ? "100%" : "auto", ({ theme: o }) => o.text.primary, ({ theme: o }) => o.primaryBackground, ({ theme: o, $noShadow: d }) => d ? "none" : `0 2px 8px 0 ${o.secondaryShadow}`, ({ theme: o, $bottomBorder: d }) => d ? `1px solid ${o.primaryBorder}` : null), m = /* @__PURE__ */ e(({ bottomBorder: o = !1, classes: d, fullWidth: r = !0, noShadow: a = !1, ...c }, i) => /* @__PURE__ */ n(p, {
  ...c,
  ref: i,
  classes: {
    ...l,
    ...d
  },
  $noShadow: a,
  $bottomBorder: o,
  $fullWidth: r
}));
m.displayName = "Accordion";
export {
  m as default
};
